import { InjectionToken, ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Inject, EventEmitter, ɵɵdirectiveInject, ElementRef, ɵɵdefineDirective, Directive, Input, ViewContainerRef, TemplateRef, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

/**
 * token to inject service by name
 */
const AUTH_SERVICE_PROVIDER_TOKEN = 'AuthenticationProvider';
//NO USAR NADA de AQUI
let AUTH_SERVICE_CONFIG_TOKEN = new InjectionToken('authservice.config');
const AUTH_SERVICE_CONFIG_DEFAULT = {
    baseUrl: "api/uploads"
};

class AuthenticationServiceAbs {
}

/**
 * Authflow is used to check user permissions
 */
class AuthFlowService {
    constructor(currentUserService) {
        //config resources
        this.currentUserService = currentUserService;
        this.isAdmin = false;
        /**
         * list of resources available
         */
        this.resourceList = [];
    }
    configure() {
        if (!this.userRoles) {
            this.userRoles = new Set(this.currentUserService.currentUserValue.profile.access_level);
            this.resourceList = this.currentUserService.currentUserValue.resourceList;
            this.isAdmin = this.userRoles.has('ADMINISTRATOR');
        }
    }
    /**
     * Not used
     * @param profilesNeeded
     */
    checkAuthorizationAsync(profilesNeeded) {
        // we are loading the roles only once
        this.configure();
        if (this.isAdmin) {
            return of(true);
        }
        return of(this.doCheckAuthorization(profilesNeeded));
    }
    /**
   *
   * @param profilesNeeded
   * @param useExactProfiles true to validate as admin profile, false to check exactly each profile
   */
    checkAuthorization(profilesNeeded, useExactProfiles = false) {
        this.configure();
        return (this.doCheckAuthorization(profilesNeeded, useExactProfiles));
    }
    doCheckAuthorization(profilesNeeded, useExactProfiles = false) {
        if (profilesNeeded.length == 0) {
            return true; //visible si no se ha marcado nada
        }
        /*     for (let x = 0; x < profilesNeeded.length; x++) {
              let prof = profilesNeeded[x];
              if (prof && prof.startsWith("COMPTYPE_")) {
                let prof_val = prof.split("_")[1];
                let companytype = Company.getCompanyType(this.currentUserService.currentUserValue.company);
                if (companytype != prof_val) {
                  return false;
                }
              }
            } */
        if (!useExactProfiles && this.isAdmin) {
            return true;
        }
        for (let x = 0; x < profilesNeeded.length; x++) {
            let prof = profilesNeeded[x];
            const res = this.userRoles.has(prof);
            if (res) {
                return true;
            }
        }
        return false;
    }
    /**
     * Recursively find workflow-map entry based on the path strings
     */
    findEntry(currentObject, keys, index = 0) {
        const key = keys[index];
        if (currentObject[key] && index < keys.length - 1) {
            return this.findEntry(currentObject[key], keys, index + 1);
        }
        else if (currentObject[key] && index === keys.length - 1) {
            return currentObject[key];
        }
        else {
            return false;
        }
    }
    /**
     * Check if user has access to resource
     * @param resourceId resource identifier
     */
    checkAuthorizationById(resourceId) {
        this.configure();
        return AuthFlowService.checkResource(this.resourceList, resourceId);
    }
    /**
     * Helper to check the access
     * @param resourceList
     * @param resourceId
     */
    static checkResource(resourceList, resourceId) {
        let resource = resourceList.find(elem => elem.resourceId == resourceId);
        if (resource) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
   * call when switch users
   */
    reset() {
        this.userRoles = null;
        this.resourceList = null;
        this.isAdmin = false;
    }
}
AuthFlowService.ɵfac = function AuthFlowService_Factory(t) { return new (t || AuthFlowService)(ɵɵinject(AUTH_SERVICE_PROVIDER_TOKEN)); };
AuthFlowService.ɵprov = ɵɵdefineInjectable({ token: AuthFlowService, factory: AuthFlowService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthFlowService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: AuthenticationServiceAbs, decorators: [{
                type: Inject,
                args: [AUTH_SERVICE_PROVIDER_TOKEN]
            }] }]; }, null); })();

class AuthGuard {
    //currentUser:any;
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    /*  constructor(
         private router: Router
     ) { } */
    canActivate(route, state) {
        return this.check(route, state);
    }
    canActivateChild(route, state) {
        return this.check(route, state);
    }
    check(route, state) {
        try {
            const currentUser = this.authenticationService.currentUserValue;
            if (!currentUser) {
                // not logged in so redirect to login page with the return url
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            let permission = route.data["Permission"];
            if (permission && permission.resourceId) {
                if (!currentUser.resourceList) {
                    //this happens only with users logged with old data
                    this.authenticationService.logout();
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return false;
                }
                let res = AuthFlowService.checkResource(currentUser.resourceList, permission.resourceId);
                if (!res) {
                    if (permission.RedirectTo && permission.RedirectTo !== undefined) {
                        this.router.navigate([permission.RedirectTo]);
                        return false;
                    }
                    else {
                        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                        return false;
                    }
                }
            }
            return true;
        }
        catch (err) {
            this.router.navigate(['/500'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵɵinject(Router), ɵɵinject(AUTH_SERVICE_PROVIDER_TOKEN)); };
AuthGuard.ɵprov = ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Router }, { type: AuthenticationServiceAbs, decorators: [{
                type: Inject,
                args: [AUTH_SERVICE_PROVIDER_TOKEN]
            }] }]; }, null); })();

/**
 * Helper class to check permissions
 */
class BasePermissionHelper {
    /*
    Movida a aplicacion principal
     public static resourceGetRoles(resourceId:string):string[] {
        let resource = appcontrols.find(elem => elem.resourceId == resourceId);
        return resource.roles;
    } */
    static checkUserACL(ACLList, permissionsToCheck) {
        try {
            //console.log("checkUserSiteACL", siteOrPermissionsList);
            if (!ACLList) {
                return false;
            }
            let entityPermissions = null;
            /*             if (typeof (ACLList) === "object") {
                            esto ya no sirve, era cuando los permisos vendrian en el objeto site
                            let siteOrPermissionsListA: Site = <Site>ACLList;
                            sitePermissions = siteOrPermissionsListA.permissions;
                        }
                        else  */
            if (Array.isArray(ACLList)) {
                entityPermissions = ACLList;
            }
            else {
                throw "checkUserSiteACL permissions must be an array.";
            }
            if (!entityPermissions) {
                return false;
            }
            for (let perm of permissionsToCheck) {
                let hasAccess = entityPermissions.find(p => p.toUpperCase() == perm.toUpperCase());
                if (hasAccess) {
                    return true;
                }
            }
            return false;
        }
        catch (err) {
            console.error(err);
            return false;
        }
    }
}

class PermissionService {
    constructor() {
        this._permissionStore = [];
        this._permissionStoreChange = new EventEmitter();
    }
    define(permissions) {
        if (!Array.isArray(permissions))
            throw "permissions parameter is not array.";
        this.clearStore();
        for (let permission of permissions)
            this.add(permission);
    }
    add(permission) {
        if (typeof permission === "string" && !this.hasDefined(permission.toLocaleLowerCase())) {
            this._permissionStore.push(permission.toLocaleLowerCase());
            this._permissionStoreChange.emit(null);
        }
    }
    remove(permission) {
        if (typeof permission !== "string")
            return;
        let index = this._permissionStore.indexOf(permission.toLowerCase());
        if (index < 0)
            return;
        this._permissionStore.splice(index, 1);
        this._permissionStoreChange.emit(null);
    }
    hasDefined(permission) {
        if (typeof permission !== "string")
            return false;
        let index = this._permissionStore.indexOf(permission.toLowerCase());
        return index > -1;
    }
    hasOneDefined(permissions) {
        if (!Array.isArray(permissions))
            throw "permissions parameter is not array.";
        return permissions.some(v => {
            if (typeof v === "string")
                return this._permissionStore.indexOf(v.toLowerCase()) >= 0;
        });
    }
    clearStore() {
        this._permissionStore = [];
    }
    get store() {
        return this._permissionStore;
    }
    get permissionStoreChangeEmitter() {
        return this._permissionStoreChange;
    }
}
PermissionService.ɵfac = function PermissionService_Factory(t) { return new (t || PermissionService)(); };
PermissionService.ɵprov = ɵɵdefineInjectable({ token: PermissionService, factory: PermissionService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PermissionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class PermissionDirectiveHelper {
    constructor() { }
    ApplyStrategie(strategie, element) {
        switch (strategie) {
            case "contshow":
                return true;
                break;
            case "enable":
                element.nativeElement.removeAttribute("disabled");
                break;
            case "disable":
                element.nativeElement.setAttribute("disabled", "true");
                break;
            case "show":
                element.nativeElement.style.display = 'inherit';
                break;
            case "hide":
                element.nativeElement.style.display = 'none';
                break;
            default:
                throw "onUnauthorized attribute is function or one of this items: <enable, disable, show, hide>";
        }
    }
}
PermissionDirectiveHelper.ɵfac = function PermissionDirectiveHelper_Factory(t) { return new (t || PermissionDirectiveHelper)(); };
PermissionDirectiveHelper.ɵprov = ɵɵdefineInjectable({ token: PermissionDirectiveHelper, factory: PermissionDirectiveHelper.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PermissionDirectiveHelper, [{
        type: Injectable
    }], function () { return []; }, null); })();

class HasPermissionDirective {
    constructor(_elem, _permissionService, _helper) {
        this._elem = _elem;
        this._permissionService = _permissionService;
        this._helper = _helper;
    }
    ngOnInit() {
        this.subscription = this._permissionService.permissionStoreChangeEmitter
            .subscribe(() => {
            this.applyPermission();
        });
        this.applyPermission();
    }
    applyPermission() {
        let hasDefined = this._permissionService.hasOneDefined(this.permissions);
        if (!hasDefined) {
            if (typeof this.onUnauthorized === "function")
                this.onUnauthorized(this._elem);
            else if (typeof this.onUnauthorized === "string")
                this._helper.ApplyStrategie(this.onUnauthorized, this._elem);
            else
                this._elem.nativeElement.style.display = 'none';
        }
        else {
            if (typeof this.onAuthorized === "function")
                this.onAuthorized(this._elem);
            else if (typeof this.onAuthorized === "string")
                this._helper.ApplyStrategie(this.onAuthorized, this._elem);
            else
                this._elem.nativeElement.style.display = '';
        }
    }
}
HasPermissionDirective.ɵfac = function HasPermissionDirective_Factory(t) { return new (t || HasPermissionDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(PermissionService), ɵɵdirectiveInject(PermissionDirectiveHelper)); };
HasPermissionDirective.ɵdir = ɵɵdefineDirective({ type: HasPermissionDirective, selectors: [["", "hasPermission", ""]], inputs: { permissions: ["hasPermission", "permissions"], onAuthorized: ["onAuthorizedPermission", "onAuthorized"], onUnauthorized: ["onUnauthorizedPermission", "onUnauthorized"] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HasPermissionDirective, [{
        type: Directive,
        args: [{
                selector: '[hasPermission]'
            }]
    }], function () { return [{ type: ElementRef }, { type: PermissionService }, { type: PermissionDirectiveHelper }]; }, { permissions: [{
            type: Input,
            args: ['hasPermission']
        }], onAuthorized: [{
            type: Input,
            args: ['onAuthorizedPermission']
        }], onUnauthorized: [{
            type: Input,
            args: ['onUnauthorizedPermission']
        }] }); })();

class ExceptPermissionDirective {
    constructor(_elem, _permissionService, _helper) {
        this._elem = _elem;
        this._permissionService = _permissionService;
        this._helper = _helper;
    }
    ngOnInit() {
        this._permissionService.permissionStoreChangeEmitter
            .subscribe(() => {
            this.applyPermission();
        });
        this.applyPermission();
    }
    applyPermission() {
        let hasDefined = this._permissionService.hasOneDefined(this.exceptPermission);
        if (hasDefined) {
            if (typeof this.onAuthorized === "function")
                this.onAuthorized(this._elem);
            else if (typeof this.onAuthorized === "string")
                this._helper.ApplyStrategie(this.onAuthorized, this._elem);
            else
                this._elem.nativeElement.style.display = 'none';
        }
        else {
            if (typeof this.onUnauthorized === "function")
                this.onUnauthorized(this._elem);
            else if (typeof this.onUnauthorized === "string")
                this._helper.ApplyStrategie(this.onUnauthorized, this._elem);
            else
                this._elem.nativeElement.style.display = '';
        }
    }
}
ExceptPermissionDirective.ɵfac = function ExceptPermissionDirective_Factory(t) { return new (t || ExceptPermissionDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(PermissionService), ɵɵdirectiveInject(PermissionDirectiveHelper)); };
ExceptPermissionDirective.ɵdir = ɵɵdefineDirective({ type: ExceptPermissionDirective, selectors: [["", "exceptPermission", ""]], inputs: { exceptPermission: "exceptPermission", onAuthorized: ["onAuthorizedPermission", "onAuthorized"], onUnauthorized: ["onUnauthorizedPermission", "onUnauthorized"] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ExceptPermissionDirective, [{
        type: Directive,
        args: [{
                selector: '[exceptPermission]'
            }]
    }], function () { return [{ type: ElementRef }, { type: PermissionService }, { type: PermissionDirectiveHelper }]; }, { exceptPermission: [{
            type: Input,
            args: ['exceptPermission']
        }], onAuthorized: [{
            type: Input,
            args: ['onAuthorizedPermission']
        }], onUnauthorized: [{
            type: Input,
            args: ['onUnauthorizedPermission']
        }] }); })();

class PermitDirective {
    constructor(_viewContainer, templateRef, authFlow) {
        this._viewContainer = _viewContainer;
        this.templateRef = templateRef;
        this.authFlow = authFlow;
        this._context = new PermitContext();
        this.exactProfile = false;
        this.permusrResValidFunc = true;
    }
    ngOnInit() {
        this.check(this.permusr);
    }
    check(value) {
        //console.log("input permusr",value);
        let valueF;
        if (typeof value === "string") {
            //value must be the identifier of the button/section or resource
            this._updateView2(value);
        }
        else if (value instanceof Object) {
            let anyval = value;
            this.permusrResValidFunc = anyval.authFunction;
            this._updateView2(anyval.id);
        }
        else if (value instanceof Array) {
            //old way
            valueF = value;
            this._context.$implicit = this._context.permusr = valueF;
            let exact = valueF[0];
            if (exact == "EXACT") {
                this.exactProfile = true;
            }
            else {
                this.exactProfile = false;
            }
            this._updateView();
        }
    }
    /**
    * to evaluate as the condition for showing the component.
    * Data mus be an array of profiles/sections to evaluate now is
    * admin=1 GEOAI
    * client=2 Exanter an others
    * client-client=3 exanter clients
    * Other type of permission is:
    * supervision-section='sec-superv-edit' Not defined yet
    * Syntax is *permusr="[2,3,'sec-superv-edit']" so auth service check if user has some of the profiles.
    */
    _updateView2(controlid) {
        let auth = false;
        //console.log("typeof(this.permusrAuthFunction)",typeof(this.permusrAuthFunction),this.permusrAuthFunction );
        //console.log("permusrResValidFunc",this.permusrResValidFunc);
        if (!this.permusrResValidFunc) {
            return;
        }
        auth = this.authFlow.checkAuthorizationById(controlid);
        if (auth && this.permusrResValidFunc) {
            this._viewContainer.clear();
            this._viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this._viewContainer.clear();
        }
    }
    _updateView() {
        let auth = false;
        //console.log("_updateView typeof(this.permusrAuthFunction)",typeof(this.permusrAuthFunction));
        if (typeof (this.permusrAuthFunction) === "function") {
            try {
                //auth=this.onAuthorizedFunction(this._context.$implicit);
                console.log("security funcion called");
            }
            catch (err) {
            }
        }
        else {
            auth = this.authFlow.checkAuthorization(this._context.$implicit, this.exactProfile);
        }
        if (auth) {
            this._viewContainer.clear();
            this._viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this._viewContainer.clear();
        }
    }
}
PermitDirective.ɵfac = function PermitDirective_Factory(t) { return new (t || PermitDirective)(ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(TemplateRef), ɵɵdirectiveInject(AuthFlowService)); };
PermitDirective.ɵdir = ɵɵdefineDirective({ type: PermitDirective, selectors: [["", "permusr", ""]], inputs: { permusr: "permusr", permusrAuthFunction: "permusrAuthFunction", permusrResValidFunc: "permusrResValidFunc", onAuthorizedCallBack: "onAuthorizedCallBack" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PermitDirective, [{
        type: Directive,
        args: [{
                selector: '[permusr]'
            }]
    }], function () { return [{ type: ViewContainerRef }, { type: TemplateRef }, { type: AuthFlowService }]; }, { permusr: [{
            type: Input
        }], permusrAuthFunction: [{
            type: Input
        }], permusrResValidFunc: [{
            type: Input
        }], onAuthorizedCallBack: [{
            type: Input
        }] }); })();
function assertCheckAuth(property, value) {
    /*         const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
            if (!isTemplateRefOrNull) {
              throw new Error(`${property} must be a TemplateRef, but received '${stringify(templateRef)}'.`);
            } */
}
/**
* @publicApi
*/
class PermitContext {
    constructor() {
        this.$implicit = null;
        this.permusr = null;
    }
}

class PermissionModule {
    static forRoot() {
        return {
            ngModule: PermissionModule,
            providers: [
                PermissionService,
                AuthGuard,
                PermissionDirectiveHelper
            ]
        };
    }
}
PermissionModule.ɵmod = ɵɵdefineNgModule({ type: PermissionModule });
PermissionModule.ɵinj = ɵɵdefineInjector({ factory: function PermissionModule_Factory(t) { return new (t || PermissionModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PermissionModule, { declarations: [HasPermissionDirective,
        ExceptPermissionDirective,
        PermitDirective], imports: [CommonModule], exports: [HasPermissionDirective,
        ExceptPermissionDirective,
        PermitDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PermissionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    HasPermissionDirective,
                    ExceptPermissionDirective,
                    PermitDirective
                ],
                exports: [
                    HasPermissionDirective,
                    ExceptPermissionDirective,
                    PermitDirective
                ],
                providers: [],
            }]
    }], null, null); })();

class ResourceRole {
    constructor() {
        this.status = 0; //0 hidden, 1 visible, 2 disabled
    }
}

class BaseauthModule {
}
BaseauthModule.ɵmod = ɵɵdefineNgModule({ type: BaseauthModule });
BaseauthModule.ɵinj = ɵɵdefineInjector({ factory: function BaseauthModule_Factory(t) { return new (t || BaseauthModule)(); }, imports: [[
            PermissionModule
        ], PermissionModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BaseauthModule, { imports: [PermissionModule], exports: [PermissionModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseauthModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    PermissionModule
                ],
                exports: [
                    PermissionModule
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of baseauth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_SERVICE_CONFIG_DEFAULT, AUTH_SERVICE_CONFIG_TOKEN, AUTH_SERVICE_PROVIDER_TOKEN, AuthFlowService, AuthGuard, AuthenticationServiceAbs, BasePermissionHelper, BaseauthModule, ExceptPermissionDirective, HasPermissionDirective, PermissionModule, PermissionService, PermitContext, PermitDirective, ResourceRole };
//# sourceMappingURL=baseauth.js.map
